import { useState, useEffect, useCallback } from 'react';
import { getUserLists } from '../api/auth';
import dayjs from 'dayjs';

const useUserLists = (storeId, startDate, endDate, page = 1, size = 10, searchField, searchValue, programId) => {
  const [userLists, setUserLists] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      if (storeId) {
        const searchParams = {};
        if (searchField && searchValue) searchParams[searchField] = searchValue;
        if (programId) searchParams.programId = programId;
        const response = await getUserLists(
          storeId,
          startDate ? dayjs(startDate).format("YYYY-MM-DD") : undefined,
          endDate ? dayjs(endDate).format("YYYY-MM-DD") : undefined,
          page,
          size,
          searchParams
        );
        setUserLists(response.data);
        setTotalCount(response.totalCount);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, [storeId, startDate, endDate, page, size, searchField, searchValue, programId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { userLists, totalCount, loading, error, refresh: fetchData };
};

export default useUserLists;
